import { useState, useEffect } from "react"

const STORAGE_KEY = "iridium-analytics-theme"

export function useTheme() {
  // Initialize from localStorage, default to "dark"
  const [theme, setThemeState] = useState(() => {
    if (typeof window === "undefined") return "dark"
    return localStorage.getItem(STORAGE_KEY) || "dark"
  })

  // Apply theme class to document
  useEffect(() => {
    const root = window.document.documentElement
    
    if (theme === "dark") {
      root.classList.add("dark")
    } else {
      root.classList.remove("dark")
    }
    
    // Persist to localStorage
    localStorage.setItem(STORAGE_KEY, theme)
  }, [theme])

  const setTheme = (newTheme) => {
    setThemeState(newTheme)
  }

  const toggleTheme = () => {
    setThemeState((prev) => (prev === "dark" ? "light" : "dark"))
  }

  return { theme, setTheme, toggleTheme, isDark: theme === "dark" }
}
